import { where, orderBy } from 'firebase/firestore'

export const lt = (field: string, value: string) => where(field, '<', value)
export const lte = (field: string, value: string) => where(field, '<=', value)
export const eq = (field: string, value: string) =>  where(field, '==', value)
export const gt = (field: string, value: string) => where(field, '>', value)
export const gte = (field: string, value: string) => where(field, '>=', value)
export const notEqual = (field: string, value: string) => where(field, '!=', value)
export const inArray = (field: string, value: string[]) => where(field, 'in', value)
export const notInArray = (field: string, value: string[]) => where(field, 'not-in', value)
export const arrayContains = (field: string, value: string[]) => where(field, 'array-contains', value)
export const arrayContainsAny = (field: string, value: string[]) => where(field, 'array-contains-any', value)

export const orderByAsc = (field: string) => orderBy(field, 'asc')
export const orderByDesc = (field: string) => orderBy(field, 'desc')

// Date filters
// last N days
export const dateFieldLastNDays = (field: string, days: number) => {
  const date = new Date()
  date.setDate(date.getDate() - days)
  return gte(field, date.toISOString())
}

// last N weeks
export const dateFieldLastNWeeks = (field: string, weeks: number) => {
  const date = new Date()
  date.setDate(date.getDate() - weeks * 7)
  return gte(field, date.toISOString())
}

// last N months
export const dateFieldLastNMonths = (field: string, months: number) => {
  const date = new Date()
  date.setMonth(date.getMonth() - months)
  return gte(field, date.toISOString())
}

// last N Years
export const dateFieldLastNYears = (field: string, years: number) => {
  const date = new Date()
  date.setFullYear(date.getFullYear() - years)
  return gte(field, date.toISOString())
}

// this month
export const dateFieldthisMonth = (field: string) => {
  const date = new Date()
  date.setDate(1)
  return gte(field, date.toISOString())
}

// last month
export const dateFieldLastMonth = (field: string) => {
  const date = new Date()
  date.setMonth(date.getMonth() - 1)
  date.setDate(1)
  return gte(field, date.toISOString())
}

// this quarter
export const dateFieldthisQuarter = (field: string) => {
  const date = new Date()
  const quarter = Math.floor((date.getMonth() / 3))
  date.setMonth(quarter * 3)
  date.setDate(1)
  return gte(field, date.toISOString())
}

// last quarter
export const dateFieldLastQuarter = (field: string) => {
  const date = new Date()
  const quarter = Math.floor((date.getMonth() / 3))
  date.setMonth(quarter * 3 - 3)
  date.setDate(1)
  return gte(field, date.toISOString())
}

// this year
export const dateFieldthisYear = (field: string) => {
  const date = new Date()
  date.setMonth(0)
  date.setDate(1)
  return gte(field, date.toISOString())
}

// last year
export const dateFieldLastYear = (field: string) => {
  const date = new Date()
  date.setFullYear(date.getFullYear() - 1)
  date.setMonth(0)
  date.setDate(1)
  return gte(field, date.toISOString())
}

// between dates
export const dateFieldBetween = (field: string, startDate: string, endDate: string) => {
  return gte(field, startDate) && lte(field, endDate)
}

// date range constants
export const dateRangeConstants = {
  'last_7_days': '7d',
  'last_30_days': '30d',
  'last_90_days': '90d',
  'last_365_days': '365d',
  'last_1_week': '1w',
  'last_4_weeks': '4w',
  'last_12_weeks': '12w',
  'last_52_weeks': '52w',
  'last_1_month': '1m',
  'last_3_months': '3m',
  'last_6_months': '6m',
  'last_12_months': '12m',
  'last_1_year': '1y',
  'last_2_years': '2y',
  'last_3_years': '3y',
  'last_4_years': '4y',
  'this_month': 'this_month',
  'last_month': 'last_month',
  'this_quarter': 'this_quarter',
  'last_quarter': 'last_quarter',
  'this_year': 'this_year',
  'last_year': 'last_year',
}

// date range filter map
export const dateRangeFilterMap = {
  '7d': dateFieldLastNDays,
  '30d': dateFieldLastNDays,
  '90d': dateFieldLastNDays,
  '365d': dateFieldLastNDays,
  '1w': dateFieldLastNWeeks,
  '4w': dateFieldLastNWeeks,
  '12w': dateFieldLastNWeeks,
  '52w': dateFieldLastNWeeks,
  '1m': dateFieldLastNMonths,
  '3m': dateFieldLastNMonths,
  '6m': dateFieldLastNMonths,
  '12m': dateFieldLastNMonths,
  '1y': dateFieldLastNYears,
  '2y': dateFieldLastNYears,
  '3y': dateFieldLastNYears,
  '4y': dateFieldLastNYears,
  'this_month': dateFieldthisMonth,
  'last_month': dateFieldLastMonth,
  'this_quarter': dateFieldthisQuarter,
  'last_quarter': dateFieldLastQuarter,
  'this_year': dateFieldthisYear,
  'last_year': dateFieldLastYear,
}

// date range filter function
export const dateRangeFilter = (field: string, dateRange: string) => {
  if (!dateRangeFilterMap[dateRange]) return

  // get number of days, weeks, months, years
  // use regex to extract the number and the unit
  const matches = dateRange.match(/(\d+)([dwmy])/)
  if (!matches) {
    return dateRangeFilterMap[dateRange](field)
  } else {
    const value = parseInt(matches[1])
    return dateRangeFilterMap[dateRange](field, value)
  }
}
